import script from "./page-layout-cell.vue?vue&type=script&setup=true&lang=js"
export * from "./page-layout-cell.vue?vue&type=script&setup=true&lang=js"

import "./page-layout-cell.vue?vue&type=style&index=0&id=2f4b2668&lang=scss"

const __exports__ = script;

export default __exports__